import React, { Component } from "react";
import styles from "../../thema/style";

export default class PageTitle extends Component {
  render() {
    return (
      <div className="row">
        <div className={`col-md-12 ${styles.pageTitle}`}>
          {/* <h2>{this.props.title}</h2> */}
          <h2>{this.props.title}</h2>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/PageTitle.js